import { z } from "zod";
import { isValidPhoneNumber } from "libphonenumber-js";

// Messages are i18n keys (resolved via t() at the point of display), not
// English text, since Zod schemas are built once at module load and have no
// access to the active language.
export const emailSchema = z
  .string()
  .min(1, "validation.emailRequired")
  .email("validation.emailInvalid");

export const phoneSchema = z
  .string()
  .min(1, "validation.phoneRequired")
  .refine((val) => isValidPhoneNumber(val), "validation.phoneInvalid");

export const nameSchema = z
  .string()
  .min(1, "validation.nameRequired")
  .regex(/^[a-zA-Z\s_-]+$/, "validation.nameInvalidChars");
